export function RenderError(props: { error: unknown }) {
  if (props.error == null) return null;

  if (typeof props.error === "string") {
    return <>{props.error}</>;
  }

  if (typeof props.error === "object" && props.error instanceof Error) {
    return <>{props.error.message}</>;
  }

  return <>{JSON.stringify(props.error)}</>;
}
